import { Mail, Handshake, ArrowUpRight } from "lucide-react";
import { CONTACT_EMAIL, CONTACT_MAILTO, partnershipMailto } from "../lib/site";

export function EmailLink({ className = "", testid = "contact-email-link", subject }) {
  return (
    <a
      href={subject ? partnershipMailto(subject) : CONTACT_MAILTO}
      className={`text-indigo-800 hover:text-indigo-950 underline underline-offset-4 decoration-indigo-200 hover:decoration-indigo-800 transition-colors whitespace-nowrap ${className}`}
      data-testid={testid}
    >
      {CONTACT_EMAIL}
    </a>
  );
}

export function DirectEmailCard() {
  return (
    <div className="bg-surface border border-neutral-200 rounded-xl p-7" data-testid="direct-email-card">
      <div className="w-10 h-10 rounded-full bg-indigo-50 text-indigo-800 flex items-center justify-center mb-5">
        <Mail size={17} />
      </div>
      <p className="eyebrow mb-2">Email us directly</p>
      <a
        href={CONTACT_MAILTO}
        className="group inline-flex items-center gap-1.5 font-playfair text-lg sm:text-xl text-neutral-900 hover:text-indigo-800 transition-colors [overflow-wrap:anywhere]"
        data-testid="contact-page-email"
      >
        {CONTACT_EMAIL}
        <ArrowUpRight size={18} className="shrink-0 text-indigo-800 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
      </a>
      <p className="text-sm text-neutral-600 leading-relaxed mt-3">
        Our official address for reader questions, corrections and general inquiries.
      </p>
    </div>
  );
}

export function PartnershipCard() {
  return (
    <div className="bg-section/60 border border-neutral-200 rounded-xl p-7" data-testid="partnership-card">
      <div className="w-10 h-10 rounded-full bg-surface text-indigo-800 flex items-center justify-center mb-5 border border-neutral-200">
        <Handshake size={17} />
      </div>
      <p className="eyebrow mb-2">Partnerships</p>
      <h3 className="font-playfair text-xl text-neutral-900 mb-3">For SaaS companies and partners</h3>
      <p className="text-sm text-neutral-600 leading-relaxed mb-4">
        SaaS companies, affiliate program managers and potential partners can reach our editorial
        team at the same address. Partnerships never determine our editorial recommendations.
      </p>
      <EmailLink subject="Partnership inquiry" testid="partnership-email-link" className="text-sm font-semibold" />
    </div>
  );
}
